import { apiRequest } from '@/utils/api-request';
import type {
  ListScheduledRunsParams,
  ListScheduledRunsResponse,
} from '@/types/schedules';

export async function listScheduledRuns(
  orgId: string,
  params: ListScheduledRunsParams = {},
): Promise<ListScheduledRunsResponse> {
  const query = new URLSearchParams();
  query.set('trigger_type', 'scheduled');
  if (params.scheduleId) query.set('schedule_id', params.scheduleId);
  if (params.dateFrom) query.set('date_from', params.dateFrom);
  if (params.dateTo) query.set('date_to', params.dateTo);
  if (params.limit != null) query.set('limit', String(params.limit));
  if (params.offset != null) query.set('offset', String(params.offset));

  const response = await apiRequest<ListScheduledRunsResponse>({
    url: `/api/v1/orgs/${orgId}/runs?${query.toString()}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  const data = response.data || response;
  return data as ListScheduledRunsResponse;
}
